import React, { Suspense } from "react";
import { Node_Type } from "./../../ricos-types/index.js";
const SmartBlock = React.lazy(
  () => import(
    /* webpackChunkName: "ricos_plugin_smartBlock_lazy" */
    "./smart-block.js"
  )
);
const SmartBlockCell = React.lazy(
  () => import(
    /* webpackChunkName: "ricos_plugin_smartBlockCcell_lazy" */
    "./smart-block-cell.js"
  )
);
const SmartBlockRenderer = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(SmartBlock, { key: node.id, node, ...props });
};
const SmartBlockLazy = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(Suspense, { fallback: "" }, /* @__PURE__ */ React.createElement(SmartBlockRenderer, { key: node.id, node, ...props }));
};
const SmartBlockCellRenderer = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(SmartBlockCell, { key: node.id, node, ...props });
};
const SmartBlockCellLazy = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(Suspense, { fallback: "" }, /* @__PURE__ */ React.createElement(SmartBlockCellRenderer, { key: node.id, node, ...props }));
};
const nodeViewRenderers = {
  [Node_Type.SMART_BLOCK]: SmartBlockLazy,
  [Node_Type.SMART_BLOCK_CELL]: SmartBlockCellLazy
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=node-view-renderers-lazy.js.map
